const {HabiBaseHost} = require('@xc/hiya-host');
const ROOTS = {
  host: {
    development: `http://${HabiBaseHost.test.api}`,
    test: `http://${HabiBaseHost.test.api}`,
    production: `http://${HabiBaseHost.prod.api}`,
  }
}

const roots2Proxies = (env) =>
  Object.entries(ROOTS).map(([key, value]) => {
    return {
      match: `/${key}`,
      map: (path) => path.replace(`/${key}`, ''),
      host: value[env],
    }
  })
module.exports = {
  ROOTS,
  production: {
    ENV: 'production',
    staticServerIps: ['10.0.2.184','10.0.2.183','10.0.0.27'],
    staticServerHost: 'static.habi.cc',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    staticServerIps: ['172.30.0.38'],
    staticServerHost: 'static-habib-test.youyisia.com',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
